export default __webpack_public_path__ + "static/media/TF_13.5186e3b8.png";